// extracted by mini-css-extract-plugin
export default {"modalOverlay":"styles_modalOverlay__WfhPY","modalContent":"styles_modalContent__fpm9H","header":"styles_header__qolxm","form":"styles_form__dY03E"};